import React, { Component } from "react";
import history from "../../login/history";
import { trackPromise, promiseTrackerHoc } from "react-promise-tracker";
import Popup from "react-popup";
import Select from "react-select";
import CampoFecha from "../../../generico/Fecha";
import SubsidiosService from "../../../../services/solicitudes/SubsidiosService";
import $ from "jquery";
import SelectComponente from "../../../generico/SelectComponente";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";


export default class AgregarSubsidioPaso2 extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    sexoOptions: [
      {value: 'F', label: 'Femenino'},
      {value: 'M', label: 'Masculino'},
    ],
    nacionalidadOptions: [],
    nroNacionalidad: undefined,
    nacDescripcion: undefined,
    primerNombreRn: undefined,
    segundoNombreRn: undefined,
    primerApellidoRn: undefined,
    segundoApellidoRn: undefined,
    sexoRn: undefined,
    fechaNacimientoRn: undefined,
    libro: undefined,
    folio: undefined,
    acta: undefined,
    //Validacion
    disableSgte: true,
    sexoVal: false
  });

  componentDidMount() {
    this.getNacionalidades();
  }

  /**************************
 * OBTENER NACIONALIDADES *
 **************************/

   getNacionalidades() {
    var options = [];
    trackPromise(
      SubsidiosService.obtenerNacionalidades()
        .then((response) => {
          var data = JSON.stringify(response.data);
          //console.log("datos", data)
          var jsonData = JSON.parse(data);
          if (jsonData.codigo === 0) {
            for (var i = 0; i < jsonData.datos.length; i++) {
              options.push({
                value: jsonData.datos[i].numero,
                label:  jsonData.datos[i].descripcion
              });
            }
            this.setState({ nacionalidadOptions: options });
          }
          else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }
        }
        ));
    return options;
  }
  
  loadNacionalidades = () => {
    if (this.state.nacionalidadOptions !== undefined) {
      return this.state.nacionalidadOptions
    }
    else {
      return this.getNacionalidades();
    }
  }

  selectorValueNac = (dataFromChild, item) => {
    console.log(dataFromChild)
    if (dataFromChild === undefined) {
      this.setState({
        nroNacionalidad: undefined,
      }, () => {this.handleValicacion()});
      return
    }
    this.setState({
      nroNacionalidad: dataFromChild,
      nacDescripcion: item.label,
    }, () => {this.handleValicacion()});
  };


/******************
 * HANDLE CHANGES *
 ******************/
  handleValidateFocus = () => {
    this.validarCampos()
  }

  handleChangePrimerNombre = (e) => {
    if(e.target.value.trim() === "") {
      this.setState({ primerNombreRn: undefined, disableSgte: true }, () => {
        this.handleValicacion();
      });
      return;
    }
    this.setState({ primerNombreRn: e.target.value }, () => {
      this.handleValicacion();
    });
  };

  handleChangeSegundoNombre = (e) => {
    if(e.target.value.trim() === "") return;
    this.setState({ segundoNombreRn: e.target.value });
  };

  handleChangePrimerApellido = (e) => {
    if(e.target.value.trim() === "") {
      this.setState({ primerApellidoRn: undefined, disableSgte: true }, () => {
        this.handleValicacion();
      });
      return;
    }
    this.setState({ primerApellidoRn: e.target.value }, 
      () => {this.handleValicacion()});
  };

  handleChangeSegundoApellido = (e) => {
    this.validarCampos()
    if(e.target.value.trim() === "") return;
    this.setState({ segundoApellidoRn: e.target.value });
  };

  handleChangeSelectorSexo = (event) => {
    this.validarCampos()
      this.setState({ sexoRn: event.value, sexoVal: false }, () => {
        this.handleValicacion();
      });
  }

  handleChangeDate = (date) => {
    this.setState({ fechaNacimientoRn: date }, 
      () => {this.handleValicacion()});
  }

  handleChangeLibro = (e) => {
    if(e.target.value.trim() === "") {
      this.setState({ libro: undefined, disableSgte: true }, () => {
        this.handleValicacion();
      });
      return;
    }
    this.setState({ libro: e.target.value }, 
      () => {this.handleValicacion()});
  };

  handleChangeFolio = (e) => {
    if(e.target.value.trim() === "") {
      this.setState({ folio: undefined, disableSgte: true }, () => {
        this.handleValicacion();
      });
      return;
    }
    this.setState({ folio: e.target.value }, 
      () => {this.handleValicacion()});
  };

  handleChangeActa = (e) => {
    if(e.target.value.trim() === "") {
      this.setState({ acta: undefined, disableSgte: true }, () => {
        this.handleValicacion();
      });
      return;
    }
    this.setState({ acta: e.target.value }, () => {
      this.handleValicacion();
    });
  };

  /*********************
 * HANDLE VALIDACION *
 *********************/

   handleValicacion = () => {
    if (
      this.state.primerNombreRn &&
      this.state.primerApellidoRn &&
      this.state.sexoRn &&
      this.state.fechaNacimientoRn &&
      this.state.nroNacionalidad &&
      this.state.libro &&
      this.state.acta &&
      this.state.folio
    ) this.setState({ disableSgte: false }, () => {});
    else {
        this.setState({ disableSgte: true }, () => {});
    }
  }

  validarSelectSexo = () => {
    if(!this.state.sexoRn) this.setState(
      {
        sexoVal: true,
      },
      () => {}
    );
  }

  validarCampos = () => {

    $("#idFormRecienNacido").validate({
      onfocusout: function (element, i) {
        $(element).valid();
      },
      rules: {
        "primerNombre": 'required',
        "primerApellido": 'required',
        "libro": 'required',
        "folio": 'required',
        "acta": 'required',
      },
      messages: {
        "primerNombre": "Este campo es requerido",
        "primerApellido": "Este campo es requerido",
        "libro": "Este campo es requerido",
        "folio": "Este campo es requerido",
        "acta": "Este campo es requerido",
      },
      errorElement: "span",
      errorPlacement: function(error, element) {
        error.addClass("invalid-feedback");
        element.addClass("is-invalid");
        element.closest(".form-group").append(error);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).removeClass("is-invalid");
      },

    })

};

  /******************************************
 * CONTINUAR -> CARGA DATOS A SUBSIDIO.JS *
 ******************************************/

  volverSubsidios = (e) => {
    this.props.goToStep(1);
  };

  continuar = () => {
    this.props.respuestaPaso2b(
      this.state.primerNombreRn,
      this.state.segundoNombreRn,
      this.state.primerApellidoRn,
      this.state.segundoApellidoRn,
      this.state.sexoRn,
      this.state.fechaNacimientoRn,
      this.state.nroNacionalidad,
      this.state.nacDescripcion,
      this.state.libro,
      this.state.folio,
      this.state.acta,
    );
    this.nextStep.click();

  };

  preventDefault = (e) => {
    e.preventDefault();
  }


  render() {
    
    let nacionalidades = this.loadNacionalidades();

    return (
      <div>
        <div className="row">
          <div className="steps clearfix steps-doc">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">  
                    <span className="title_text">Selección de Cuenta</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title"> 
                    <span className="title_text current">Recién Nacido</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos Cónyuge</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Adjuntar Documentos</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <form id="idFormRecienNacido" onSubmit={this.preventDefault}>
          <div className="row justify-content-md-center">
            <div className="col-md-10">
              <div className="row">
                <div className="col-md-10">
                  <br />
                  <h5 className="card-subtitle">Datos del Recien Nacido</h5>
                  <br />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="row justify-content-md-center">
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label
                          className="input-label-bold"
                          htmlFor="primer-nombre"
                        >
                          Primer Nombre *
                        </label>
                        <input
                          name="primerNombre"
                          type="text"
                          id="primer-nombre"
                          placeholder="Ingresar primer nombre"
                          className="form-control input-box"
                          onChange={this.handleChangePrimerNombre}
                          onFocus={this.handleValidateFocus}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label
                          className="input-label-bold"
                          htmlFor="segundo-nombre"
                        >
                          Segundo Nombre
                        </label>
                        <input
                          type="text"
                          id="segundo-nombre"
                          placeholder="Ingresar segundo nombre"
                          className="form-control input-box"
                          onBlur={this.handleChangeSegundoNombre}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="row justify-content-md-center">
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label
                          className="input-label-bold"
                          htmlFor="primer-apellido"
                        >
                          Primer Apellido *
                        </label>
                        <input
                          type="text"
                          name="primerApellido"
                          id="primer-apellido"
                          placeholder="Ingresar primer apellido"
                          className="form-control input-box"
                          onChange={this.handleChangePrimerApellido}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label
                          className="input-label-bold"
                          htmlFor="segundo-apellido"
                        >
                          Segundo Apellido
                        </label>
                        <input
                          type="text"
                          id="segundo-apellido"
                          placeholder="Ingresar segundo apellido"
                          className="form-control input-box"
                          onBlur={this.handleChangeSegundoApellido}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="row justify-content-md-center">
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label className="input-label-bold" htmlFor="sexo">
                          Sexo *
                        </label>
                        <Select
                          id="sexo"
                          className={
                            this.state.sexoVal && "invalid-select-border"
                          }
                          onChange={this.handleChangeSelectorSexo}
                          onBlur={this.validarSelectSexo}
                          options={this.state.sexoOptions}
                          placeholder={"-- seleccione --"}
                        ></Select>
                        {this.state.sexoVal && (
                          <span className="invalid-select">
                            Este campo es requerido
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label
                          className="input-label-bold"
                          htmlFor="fecha-nacimiento"
                        >
                          Fecha de Nacimiento *
                        </label>
                        <CampoFecha
                          id="fecha-nacimiento"
                          //name="fechaNacimiento"
                          placeholder={"Ingresar fecha de nacimiento"}
                          onChange={this.handleChangeDate}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="row justify-content-md-center">
                    <div className="col-md-12">
                      {
                        <SelectComponente
                          id="nacionalidad"
                          titulo="Nacionalidad"
                          presentacion="SELECT"
                          selectorValue={this.selectorValueNac.bind(this)}
                          itemSelected={this.state.nroNacionalidad}
                          options={nacionalidades}
                          addInvalid={true}
                        />
                      }
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-10">
                  <br />
                  <h5 className="card-subtitle">Datos Civiles</h5>
                  <br />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="row justify-content-md-center">
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label className="input-label-bold" htmlFor="libro">
                          Libro *
                        </label>
                        <input
                          type="text"
                          name="libro"
                          id="libro"
                          placeholder="Ingresar libro"
                          className="form-control input-box"
                          onChange={this.handleChangeLibro}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label className="input-label-bold" htmlFor="folio">
                          Folio *
                        </label>
                        <input
                          type="text"
                          name="folio"
                          placeholder="Ingresar folio"
                          id="folio"
                          className="form-control input-box"
                          onChange={this.handleChangeFolio}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="row justify-content-md-center">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="input-label-bold" htmlFor="acta">
                          Acta *
                        </label>
                        <input
                          type="text"
                          name="acta"
                          id="acta"
                          placeholder="Ingresar acta"
                          className="form-control input-box"
                          onChange={this.handleChangeActa}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-md-12">
                  <div className="row justify-content-md-center">
                    <div className="col-lg-6 col-md-6">
                      <label className="input-label-bold-obligatorio float-left">
                        (*) Campos Obligatorios
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3">
                          <button
                      className="btn btn-cu-quintary  btn-consulta"
                      onClick={this.volverSubsidios}
                    >
                    <FontAwesomeIcon icon={faArrowLeft} /> Volver
                    </button>
                    </div>
                    <div className="col-lg-3 col-md-3">
                    <button
                    disabled={this.state.disableSgte}
                    className="btn btn-cu-primary"
                    onClick={() => {
                      this.continuar();
                    }}
                  >
                    Continuar <FontAwesomeIcon icon={faArrowRight} />
                  </button>
                  <button
                    hidden
                    ref={(a) => (this.nextStep = a)}
                    className="btn btn-cu-primary"
                    onClick={this.props.nextStep}
                  ></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          
        </form>
      </div>
    );
  }
}
